export default "__VITE_ASSET__ZR_jVJeu__"